var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 19.57v-7.14L5 8.813v6.965c0 .051.013.1.038.144a.331.331 0 00.116.116l6.096 3.532zm1.5 0l6.096-3.534a.332.332 0 00.116-.115.286.286 0 00.038-.144V8.812l-6.25 3.619v7.138zm-1.654 1.636l-6.692-3.852a1.78 1.78 0 01-.904-1.562V8.208a1.771 1.771 0 01.904-1.562l6.692-3.852a1.78 1.78 0 011.808 0l6.692 3.852a1.78 1.78 0 01.904 1.562v7.584a1.772 1.772 0 01-.904 1.562l-6.692 3.852a1.781 1.781 0 01-1.808 0zM15.856 8.9l2.319-1.33-6.021-3.484A.288.288 0 0012 4.038a.288.288 0 00-.154.048l-2.171 1.25 6.18 3.564zM12 11.139l2.325-1.347L8.15 6.223 5.825 7.569 12 11.14z",
    fill: "#FF7D6B"
  })));
}
export default SvgPackage;